import { useCallback } from "react";
import { useDispatch } from "./useDispatch";
export function useUpdateSavedValues() {
    const dispatch = useDispatch();
    return useCallback((field = [], ...fields) => {
        fields = fields.concat(field);
        dispatch({
            type: "field_patch",
            payload: {
                patches: fields.map(f => ({
                    fieldName: f.name,
                    namespace: f.namespace,
                    initialValue: f.value
                }))
            }
        });
    }, [dispatch]);
}
//# sourceMappingURL=useUpdateSavedValues.js.map